var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dr-simple-layout',{attrs:{"model":_vm.innerValue},on:{"modelChanged":_vm.onModelChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }